<script>
import { mapState } from 'vuex'
import moment from 'moment'
import ProfilePicker from '@/components/profile/ProfilePicker'

export default {
  data() {
    return {
      profileName: '',
      profileDescription: '',
      selectedProfile: null,
      menu: false,
      on: false
    }
  },

  methods: {
    async createProfile() {
      try {
        let response = await this.$store.dispatch('saveProfile', {
          name: this.profileName,
          description: this.profileDescription,
          parentProfile: this.selectedProfile
        })
        await this.$store.dispatch('directNotification', {
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description:
            'Profile ' + response.hexId + ' has been created Successfully',
          message: 'Profile has been created Successfully',
          type: 'success'
        })
        this.$store.dispatch('fetchProfiles')
        this.$router.push({ name: 'profile-tree-view' }).catch()
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          message: 'Unable to add Profile',
          type: 'error'
        })
      }
    },
    backToList() {
      this.$router
        .push({
          name: 'profile-tree-view'
        })
        .catch()
    }
  },

  computed: {
    ...mapState({
      profiles: state => {
        return state.profiles.profiles
      }
    })
  },
  watch: {
    selectedProfile(newval) {
      this.menu = false
      console.log('selectedProfile: ', newval)
    }
  },
  components: {
    ProfilePicker
  },

  created() {
    this.$store.dispatch('fetchProfiles')
  }
}
</script>
<template>
  <v-card class="card--flex-toolbar">
    <v-toolbar card dense>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="backToList">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <span>Back</span>
      </v-tooltip>
      <v-toolbar-title class="body-2">Create Profile</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 sm3>
          <v-subheader v-text="'Profile Name'" />
        </v-flex>
        <v-flex xs12 sm9>
          <v-text-field
            color="secondary"
            label="Profile Name"
            hint="Enter a name for the profile"
            persistent-hint
            v-model="profileName"
            autofocus
            required
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm3>
          <v-subheader v-text="'Profile Description'" />
        </v-flex>
        <v-flex xs12 sm9>
          <v-text-field
            color="secondary"
            label="Profile Description"
            hint="Enter description for the profile"
            persistent-hint
            v-model="profileDescription"
            required
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm3 mt-4>
          <v-subheader v-text="'Reports To'" />
        </v-flex>
        <v-flex xs12 sm9 mt-4>
          <v-menu
            style="float: left;"
            offset-x
            :close-on-content-click="false"
            :nudge-width="600"
            v-model="menu"
          >
            <template slot="activator" slot-props="{ on }">
              <v-btn class="ml-0 text-capitalize" v-on="on">
                {{ selectedProfile ? selectedProfile.name : 'Pick Profile' }}
              </v-btn>
            </template>
            <v-card>
              <profile-picker
                :mini="true"
                v-model="selectedProfile"
                :items="profiles"
              ></profile-picker>
            </v-card>
          </v-menu>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-layout justify-center>
        <v-btn @click="createProfile" accent class="primary text-capitalize">
          Create user profile
        </v-btn>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>
